import { makeStyles } from '@mui/styles';

const styles = makeStyles(({ breakpoints }) => ({
  title: {
    textAlign: 'center',
    width: '600px',
    [breakpoints.down(500)]: {
      fontSize: '18px',
      width: '100%'
    }
  },
  logo: {
    width: '70%',
    margin: 'auto',
  },
  statusMessage: {
    textAlign: 'center',
    [breakpoints.down(500)]: {
      fontSize: '18px',
      width: '100%'
    }
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: '-12px'
  }
}));

export default styles;
